module.exports = __webpack_public_path__ + "static/media/download.e9a66d9f.svg";